import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ContentService} from "../_services/content.service";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ActivatedRoute, Router} from "@angular/router";
import {LightboxComponent} from "../shared/lightbox/lightbox.component";
import {PageEvent} from "@angular/material/paginator";
import {SnackbarService} from "../_services/snackbar.service";
import {Location} from "@angular/common";
import {AuthService} from "../_services/auth.service";
import {User} from "../_types/user";
import {MediaItem} from "../_types/memorybox";

@Component({
    selector: 'app-favourites',
    templateUrl: './favourites.component.html',
    styleUrl: './favourites.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class FavouritesComponent {
    id: number = 0;
    media: MediaItem[] = [];
    permission: string = 'No permission';
    page: number = 0;
    limit: number = 15;
    user!: User;
    loading: boolean = true;
    loadFailed: boolean = false;
    count: number = 0;
    subtitle: string = 'Your favourite memories';

    constructor(
        private contentService: ContentService,
        public dialog: MatDialog,
        private route: ActivatedRoute,
        private snackbarService: SnackbarService,
        private location: Location,
        private router: Router,
        private authService: AuthService
    ) {
        if (window.innerWidth < 1600 && window.innerWidth > 1100) {
            this.limit = 16;
        }
        this.route.params
            .subscribe({
                next: params => {
                    this.id = params['id'];
                    if (this.id) {
                        this.subtitle = 'Favourite memories';
                        this.authService.getDynamicSettings().then((r): void => {
                            if (!r.is_raa) {
                                this.contentService.getUserProfile(this.id).subscribe({
                                    next: r => {
                                        this.subtitle = (this.authService.getDisplayName(r, undefined, undefined, 'timeline')) + "'s favourite memories"
                                    }, error: error => {
                                        this.router.navigate(['/people']);
                                        this.snackbarService.openSnackBar(error, 'error')
                                        console.error(error)
                                    }
                                });
                            }
                        });
                    }
                    if (params['index']) {
                        this.viewImage(params['index'])
                    }
                }, error: error => {
                    this.snackbarService.openSnackBar(error, 'error')
                    console.error(error)
                }
            });
        this.authService.getUser().subscribe({
            next: r => {
                this.user = r;
            }
        })
        this.getMedia();
    }


    getMedia(): Promise<any> {
        return new Promise((resolve, reject): void => {
            this.loading = true;
            this.loadFailed = false;
            this.contentService.getFavouriteMedia(this.page, this.limit, this.id).subscribe({
                next: r => {
                    this.count = r.count;
                    let timelineId
                    this.media = [];
                    for (let media of r.results) {
                        timelineId = media.memory.timeline.id
                        this.media.push(media.media)
                    }
                    this.loading = false;

                    if (timelineId) {
                        this.contentService.viewTimelinePermissions(timelineId).subscribe({
                            next: r => {
                                for (let permission of r) {
                                    if (permission.user.id == this.user.id) {
                                        this.permission = permission.permission
                                    }
                                }
                                if ((!this.permission || this.permission == 'No permission' || this.permission == 'Add but not View or Comment') && this.user?.role?.role_type !== 'admin') {
                                    this.snackbarService.openSnackBar('Sorry you do not have permission to view favourites', 'error');
                                    this.router.navigate(['/noAccess']);
                                }
                            }, error: error => {
                                this.router.navigate(['/noAccess']);
                                this.snackbarService.openSnackBar(error, 'error')
                                console.error(error)
                            }
                        });
                    }
                    resolve('Success')
                }, error: error => {
                    this.loading = false;
                    this.loadFailed = true;
                    reject(error)
                    this.snackbarService.openSnackBar(error, 'error')
                    console.error(error)
                }
            });
        });
    }

    back(): void {
        if (history.length > 1) {
            history.back();
        } else {
            this.router.navigate(['/timeline']);
        }
    }

    viewImage(i: number): void {
        // stop all active media
        document.querySelectorAll('video').forEach(vid => vid.pause());
        document.querySelectorAll('audio').forEach(vid => vid.pause());

        let isUsersOwnFavourites: boolean = this.id == null;
        this.dialog.closeAll();
        if (this.media[i]) {
            const dialogRef: MatDialogRef<LightboxComponent> = this.dialog.open(LightboxComponent, {
                data: {
                    media: this.media,
                    index: i,
                    permission: this.permission,
                    canFavourite: isUsersOwnFavourites,
                },
                panelClass: 'fullWidthWindow',
            });
            dialogRef.componentInstance.refresh.subscribe((index): void => {
                // Refresh favourites if when media changes
                this.getMedia().then((): void => {
                    dialogRef.close();
                    if (index) this.viewImage(index)
                });
            });
            dialogRef.componentInstance.reFetch.subscribe((): void => {
                // Refresh favourites if when media changes
                this.getMedia().then((): void => {
                    dialogRef.close();
                });
            });

            dialogRef.afterClosed().subscribe((): void => {
                // Remove index from param
                this.location.go('favourites/');
            });
        }
    }

    handlePageEvent(e: PageEvent): void {
        this.page = e.pageIndex;
        this.getMedia();
    }


}
